import React, { useEffect, useState, useContext } from "react";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { useNavigate, useLocation } from "react-router-dom";
import { setSessionData, getSessionData } from "../../cache";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import { ContextBoard } from "../../context/ContextBoard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function CorrectRegular12() {
  const {
    setCandidateid12,
    setCastecode12,
    setDivyangcode12,
    candidateid12,
    mode12,
    setMode12,
    setDocverify12,
    class12regulardata,
  } = useContext(ContextBoard);
  const location = useLocation();
  const navigate = useNavigate();

  const [candidateData, setCandidateData] = useState(
    location.state?.candidateData || {}
  );
  // const [fieldsMissing, setFieldsMissing] = useState({
  //   caste: false,
  // });
  useEffect(() => {
    if (!class12regulardata) {
      navigate("/class-xii-correct-student");
    }
    // else {
    //   setFieldsMissing({
    //     caste: !candidateData.caste,
    //   });
    // }
  }, [navigate]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [loading, setLoading] = useState(true);
  const [blockList, setBlockList] = useState([]);
  const [casteList, setCasteList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [coresubject, setCoresubject] = useState([]);
  const [matribhasa, setMatribhasa] = useState([]);
  const [compulsory, setCompulsory] = useState([]);
  const [compulsoryfilter, setCompulsoryfilter] = useState([]);
  const [artsSubjects, setArtsSubjects] = useState([]);
  const [optionalsubj, setOptionalsubj] = useState([]);
  const [optionalfiltersubj, setOptionalfiltersubj] = useState([]);
  const [additionalsubj, setAdditionalsubj] = useState([]);
  const [additionalfiltersubj, setAdditionalfiltersubj] = useState([]);
  const [electivefiltersubj, setElectivefiltersubj] = useState([]);
  const [compulsoryonename, setCompulsoryonename] = useState("");
  const [compulsorytwoname, setCompulsorytwoname] = useState("");
  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [finaledit, setFinaledit] = useState(false);

  const [formData, setFormData] = useState({
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "JAC",
    apaar_id: "",
    section_val: "",
    roll_no: "",
    class_roll_no: "",
    stream: "",
    coresubject: "",
    matribhasa: "",
    compulsory_one: "",
    compulsory_two: "",
    additionalsubject: "",
    pen_no: "",
  });
  const [selectedArtsSubjects, setSelectedArtsSubjects] = useState({
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
  });

  const [optional1, setOptional1] = useState("");
  const [optional2, setOptional2] = useState("");
  const [artselective, setArtselective] = useState("");

  const [selectedSubjectNames, setSelectedSubjectNames] = useState({
    coresubject: "",
    matribhasa: "",
    // compulsory_one: "",
    // compulsory_two: "",
    additionalsubject: "",
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
    optional1: "",
    optional2: "",
    artselective: "",
  });
  useEffect(() => {
    setLoading(true);
    if (mode12 === "edit") {
      setFinaledit(true);
      setIsEditMode(true);
      setIsPreviewed(true);
    }
    if (!candidateData) {
      navigate("/class-xii-dashboard");
      return;
    } // 🔹 Read encrypted lists from sessionStorage
    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const coreSubjects = getSessionData("coreSubjects") || [];
    const matri_BhasaSubjects = getSessionData("matri_BhasaSubjects") || [];
    const compulsory_Paper_2Subjects =
      getSessionData("compulsory_Paper_2Subjects") || [];
    const additional_Subjects = getSessionData("additional_Subjects") || [];
    const optional_Paper_1_2Subjects =
      getSessionData("optional_Paper_1_2Subjects") || [];
    const elective_Subjects = getSessionData("electivesubj") || [];
    // 🔹 Set lists into state
    setBlockList(Array.isArray(blockList) ? blockList : []);
    setCasteList(Array.isArray(casteList) ? casteList : []);
    setDistrictList(Array.isArray(districtList) ? districtList : []);
    setDivyangList(Array.isArray(divyangList) ? divyangList : []);
    setMediumList(Array.isArray(mediumList) ? mediumList : []);
    setReligionList(Array.isArray(religionList) ? religionList : []);
    setStateList(Array.isArray(stateList) ? stateList : []);
    setCoresubject(Array.isArray(coreSubjects) ? coreSubjects : []);
    setMatribhasa(
      Array.isArray(matri_BhasaSubjects) ? matri_BhasaSubjects : []
    );
    setCompulsory(
      Array.isArray(compulsory_Paper_2Subjects)
        ? compulsory_Paper_2Subjects
        : []
    );
    setAdditionalsubj(
      Array.isArray(additional_Subjects) ? additional_Subjects : []
    );
    setOptionalsubj(
      Array.isArray(optional_Paper_1_2Subjects)
        ? optional_Paper_1_2Subjects
        : []
    );
    setElectivefiltersubj(
      Array.isArray(elective_Subjects) ? elective_Subjects : []
    );
    // 🔹 Aadhaar formatting
    const stream = candidateData?.stream || "";
    const rawAadhaar = candidateData?.aadhaR_CARD || "";
    const digitsOnly = rawAadhaar.replace(/\D/g, "").slice(0, 12);
    const formattedAadhaar = digitsOnly.replace(
      /(\d{4})(\d{4})(\d{1,4})?/,
      (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" ")
    );

    // 🔹 Filter subjects by stream
    const filteredCompulsory =
      compulsory_Paper_2Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL"
      ) || [];

    const filteredOptional =
      optional_Paper_1_2Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL"
      ) || [];

    const filteredAdditional =
      additional_Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL"
      ) || [];

    // 🔹 Apply stream-based subject logic
    if (stream === "SCIENCE" || stream === "COMMERCE") {
      const [firstComp, secondComp] = filteredCompulsory;
      setCompulsoryonename(firstComp?.subjecT_NAME || "");
      setCompulsorytwoname(secondComp?.subjecT_NAME || "");

      setFormData((prev) => ({
        ...prev,
        compulsory_one: firstComp?.subjecT_ID || "",
        compulsory_two: secondComp?.subjecT_ID || "",
      }));

      setOptionalfiltersubj(filteredOptional);
      setAdditionalfiltersubj(filteredAdditional);

      setOptional1(candidateData.suB_5 || "");
      setOptional2(candidateData.suB_6 || "");
    } else if (stream === "ARTS") {
      setArtsSubjects(filteredCompulsory);
      setOptionalfiltersubj(filteredOptional);
      setAdditionalfiltersubj(filteredAdditional);
      setSelectedArtsSubjects({
        arts_optional_one: candidateData.suB_4 || "",
        arts_optional_two: candidateData.suB_5 || "",
        arts_optional_three: candidateData.suB_6 || "",
      });
      setArtselective(candidateData.suB_3 || "");
    }

    // 🔹 Set common student details
    setFormData((prev) => ({
      ...prev,
      candidate_name: candidateData?.candidatE_NAME || "",
      pen_no: candidateData?.peN_NO || "",
      gender: candidateData?.gender?.toUpperCase() || "",
      date_of_birth: candidateData?.dob || "",
      fathers_name: candidateData?.fatheR_NAME || "",
      mothers_name: candidateData?.motheR_NAME || "",
      religion: candidateData?.religion || "",
      nationality: "Indian",
      aadhaar_no: formattedAadhaar || "",
      divyang_val: candidateData?.divyang || "",
      caste_val: candidateData?.caste || "",
      area: candidateData?.area || "",
      state_val: candidateData?.state || "",
      district_val: candidateData?.districT_ID || "",
      block_val: candidateData?.block || "",
      address_val: candidateData?.address || "",
      pin_no: candidateData?.pincode || "",
      contact_no: candidateData?.contacT_NO || "",
      email_id: candidateData?.emaiL_ID || "",
      category_choice: candidateData?.studenT_EXAM_SUB_CATEGORY || "",
      section_val: candidateData?.section || "",
      roll_no: candidateData?.clasS_ROLL_NO || "",
      class_roll_no: candidateData?.olD_ROLL_NO || "",
      stream: candidateData.stream || "",
      coresubject: candidateData?.suB_1 || "",
      matribhasa: candidateData?.suB_2 || "",
      additionalsubject: candidateData?.suB_7 || "",
      apaar_id: candidateData.apaaR_ID || "",
    }));

    setLoading(false);
  }, []);

  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    if (name === "religion") {
      formattedValue = value;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handlePreview = async () => {
    setIsAgreed(false);
    setLoading(true);
    const trimmed = (val) => (val || "").trim();

    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");
      if (penno && penno.length >= 11 && penno.length <= 14) {
        const token = sessionStorage.getItem("tokenclassxii");
        try {
          const response = await fetch(
            `${config.API_BASE_URL}/PENNoCheckingStudentData_CL12`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                candidatE_ID: candidateData.candidatE_ID || "",
                peN_NO: penno,
              }),
            }
          );
          const result = await response.json();

          if (result.status === 404) {
            Swal.fire({
              icon: "warning",
              title: "PEN No. Already Exists.",
            });
            setFormData((prev) => ({
              ...prev,
              pen_no: "",
            }));
            setLoading(false);
            return;
          }
        } catch (error) {
          console.error("Error verifying PEN No.", error);
          setLoading(false);
          return;
        }
      }
    }

    const newErrors = {};

    if (!formData.divyang_val) {
      newErrors.divyang_val = "Divyang selection is required.";
    }
    if (!formData.religion) {
      newErrors.religion = "Religion is required.";
    }
    if (!trimmed(formData.pen_no)) {
      newErrors.pen_no = "PEN No. is required.";
    } else if (!/^\d{11,14}$/.test(formData.pen_no)) {
      newErrors.pen_no = "PEN No. must be between 11 to 14 digits.";
    }
    if (!/^\d{12}$/.test(formData.apaar_id) && formData.apaar_id) {
      newErrors.apaar_id = "Apaar ID must be exactly 12 digits.";
    }
    if (formData.stream === "SCIENCE" || formData.stream === "COMMERCE") {
      if (!formData.coresubject) {
        newErrors.coresubject = "Core Language is Required.";
      }
      if (formData.coresubject === "HNB") {
        if (!formData.matribhasa) {
          newErrors.matribhasa = "Matri Bhasa is Required.";
        }
      }
      if (!optional1) {
        newErrors.sc_optional_one = "Optional 1 is Required.";
      }
      if (!optional2) {
        newErrors.sc_optional_two = "Optional 2 is Required.";
      }
    }
    if (formData.stream === "ARTS") {
      if (!formData.coresubject) {
        newErrors.coresubject = "Core Language is Required.";
      }
      if (formData.coresubject === "HNB") {
        if (!formData.matribhasa) {
          newErrors.matribhasa = "Matri Bhasa is Required.";
        }
      }
      if (!selectedArtsSubjects.arts_optional_one) {
        newErrors.arts_optional_one = "Optional 1 is Required.";
      }
      if (!selectedArtsSubjects.arts_optional_two) {
        newErrors.arts_optional_two = "Optional 2 is Required.";
      }
      if (!selectedArtsSubjects.arts_optional_three) {
        newErrors.arts_optional_three = "Optional 3 is Required.";
      }
      if (!artselective) {
        newErrors.arts_elective_one = "Elective Language is Required.";
      }
    }
    setErrors(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;

    if (!noErrors) {
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsPreviewed(true);
    }
    setLoading(false);
  };
  const handleButtonClick = () => {
    // const isEditMode = mode12;
    // if (isEditMode === "edit") {
    handleEditSubmit();
    // } else {
    //   handleSubmit();
    // }
  };

  const handleEditSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassxii");

    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    /* =========================
     BASE PAYLOAD
  ========================= */
    let payload = {
      candidatE_CODE: candidateData?.candidatE_ID || null,
      refferencE_NO: candidateData?.registratioN_ID_CL_11 || null,
      divyang: formData?.divyang_val || null,
      religion: formData?.religion || null,
      apaaR_ID: formData?.apaar_id || null,
      peN_NO: formData?.pen_no || null,
    };

    /* =========================
     SUBJECT PAYLOAD
  ========================= */
    if (formData.stream === "SCIENCE" || formData.stream === "COMMERCE") {
      payload = {
        ...payload,
        // subjecT_1_A_TYPE: "CL",
        subjecT_1_A_CODE: formData.coresubject || null,
        // subjecT_1_B_TYPE: "MB",
        subjecT_1_B_CODE: formData.matribhasa || null,
        // subjecT_2_TYPE: "C1",
        subjecT_2_CODE: formData.compulsory_one || null,
        // subjecT_3_TYPE: "C2",
        subjecT_3_CODE: formData.compulsory_two || null,
        // subjecT_4_TYPE: "O1",
        subjecT_4_CODE: optional1 || null,
        // subjecT_5_TYPE: "O2",
        subjecT_5_CODE: optional2 || null,
        // subjecT_6_TYPE: "AL",
        subjecT_6_CODE: formData.additionalsubject || null,
      };
    } else if (formData.stream === "ARTS") {
      payload = {
        ...payload,
        // subjecT_1_A_TYPE: "CL",
        subjecT_1_A_CODE: formData.coresubject || null,
        // subjecT_1_B_TYPE: "MB",
        subjecT_1_B_CODE: formData.matribhasa || null,
        // subjecT_2_TYPE: "EL",
        subjecT_2_CODE: artselective || null,
        // subjecT_3_TYPE: "O1",
        subjecT_3_CODE: selectedArtsSubjects?.arts_optional_one || null,
        // subjecT_4_TYPE: "O2",
        subjecT_4_CODE: selectedArtsSubjects?.arts_optional_two || null,
        // subjecT_5_TYPE: "O3",
        subjecT_5_CODE: selectedArtsSubjects?.arts_optional_three || null,
        // subjecT_6_TYPE: "AL",
        subjecT_6_CODE: formData.additionalsubject || null,
      };
    }

    /* =========================
     API CALL
  ========================= */
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminUpdateRegularStudentCorrection_CL12`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setCandidateid12(candidateData?.candidatE_ID || "");
        setCastecode12(formData?.caste_val || "");
        setDivyangcode12(formData?.divyang_val || "");

        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data updated successfully",
          confirmButtonText: "OK",
        });

        setCandidateData({});
        setDocverify12(false);
        setMode12("edit");
        navigate("/class-xii-upload-document");
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data?.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.message || "Something went wrong. Please try again later.",
      });
    }
  };

  const handlePenBlur = async () => {
    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");

      if (!penno || penno.length < 11 || penno.length > 14) return;

      const token = sessionStorage.getItem("tokenclassxii");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/PENNoCheckingStudentData_CL12`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: candidateData.candidatE_ID || "",
              peN_NO: penno,
            }),
          }
        );

        const result = await response.json();

        if (result.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "PEN(Permanent Education Number) No. Already Exists.",
            // text: "Aadhaar Number Already Exists.",
          });
          setFormData((prev) => ({
            ...prev,
            pen_no: "",
          }));

          return;
        }
        // console.log("Aadhaar verification result:", result);
      } catch (error) {
        console.error("Error verifying PEN No.", error);
      }
    }
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };

  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    setCandidateid12(candidateid12 || "");
    setCastecode12(formData.caste_val || "");
    setDivyangcode12(formData.divyang_val || "");
    if (finaledit === false) {
      setDocverify12(true);
      navigate("/class-xii-upload-document");
    } else {
      navigate("/class-xii-upload-document");
    }
  };
  const handleArtsOptionalChange = (e) => {
    const { name, value } = e.target;

    setSelectedArtsSubjects((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    // ✅ Hindi restrictions
    if (
      formData.coresubject === "HNA" &&
      (formData.additionalsubject === "HIN" || artselective === "HIN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "HIN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }
    if (formData.coresubject === "HNA" && artselective === "HIN") {
      setArtselective("");
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
    }
    // ✅ English restrictions
    if (
      formData.coresubject === "ENA" &&
      (formData.additionalsubject === "ENG" ||
        formData.additionalsubject === "FEN" ||
        artselective === "ENG" ||
        artselective === "FEN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "ENG" || artselective === "FEN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }

    // ✅ Science stream restrictions
    if (formData.stream === "SCIENCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Commerce stream restrictions
    if (formData.stream === "COMMERCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Arts stream restrictions
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "MAT" ||
        arts_optional_two === "MAT" ||
        arts_optional_three === "MAT"
      ) {
        if (
          formData.additionalsubject === "MAT" ||
          formData.additionalsubject === "STA"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }

      // If STA selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "STA" ||
        arts_optional_two === "STA" ||
        arts_optional_three === "STA"
      ) {
        if (
          formData.additionalsubject === "STA" ||
          formData.additionalsubject === "MAT"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }
    }
  }, [
    formData.coresubject,
    formData.stream,
    formData.additionalsubject,
    optional1,
    optional2,
    selectedArtsSubjects,
  ]);

  useEffect(() => {
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT is selected anywhere → reset STA from additional subject
      if (
        (arts_optional_one === "MAT" ||
          arts_optional_two === "MAT" ||
          arts_optional_three === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA is selected anywhere → reset MAT from additional subject
      if (
        (arts_optional_one === "STA" ||
          arts_optional_two === "STA" ||
          arts_optional_three === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [
    formData.stream,
    formData.additionalsubject,
    selectedArtsSubjects.arts_optional_one,
    selectedArtsSubjects.arts_optional_two,
    selectedArtsSubjects.arts_optional_three,
  ]);

  useEffect(() => {
    // 🔹 Science stream MAT–STA restrictions
    if (formData.stream === "SCIENCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be STA
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }

    // 🔹 Commerce stream MAT–CAE restrictions
    if (formData.stream === "COMMERCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be CAE
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If CAE chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [formData.stream, formData.additionalsubject, optional1, optional2]);
  const handleArtsSubjects = () => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    // Include ARTS + ALL
    const filtered = compulsory.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    setArtsSubjects(filtered);

    const filteredOptional = optionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    const filteredadditional = additionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL"
    );
    setAdditionalfiltersubj(filteredadditional);
    setOptionalfiltersubj(filteredOptional);
  };

  const handleSetCompulsorySubjects = (selectedStream) => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    if (!Array.isArray(compulsory)) return;
    if (!Array.isArray(optionalsubj)) return;
    if (!Array.isArray(additionalsubj)) return;

    // Include selected stream + ALL
    const filteredSubjects = compulsory.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );
    const filteredOptionalSubjects = optionalsubj.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );
    const filteredadditionalSubjects = additionalsubj.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL"
    );

    setAdditionalfiltersubj(filteredadditionalSubjects);
    setOptionalfiltersubj(filteredOptionalSubjects);

    const [firstSubject, secondSubject] = filteredSubjects;
    setCompulsoryonename(firstSubject?.subjecT_NAME || "");
    setCompulsorytwoname(secondSubject?.subjecT_NAME || "");

    setFormData((prev) => ({
      ...prev,
      compulsory_one: firstSubject?.subjecT_ID || "",
      compulsory_two: secondSubject?.subjecT_ID || "",
    }));
  };
  return (
    <>
      <div class="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar12 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar12 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Correct Regular /
                      Private Student (Student Correction Page for Board
                      Examination)
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/class-xii-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Correct Student</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 stretch-card mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h5 class="mb-0 p-2">
                        Class XI Examination Passing Details
                      </h5>
                    </div>
                    <div class="card-body">
                      <div
                        class="row d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div class="col-md-10 py-3">
                          <div class="row">
                            <label class="col-md-3">Passing Year :</label>
                            <div class="col-md-2">
                              <input
                                type="text"
                                class="form-control form-control-xs"
                                value={candidateData.passinG_YEAR}
                                disabled
                              />
                            </div>
                          </div>

                          <div class="row mt-3">
                            <label class="col-md-3">Roll Code:</label>
                            <div class="col-md-3">
                              <input
                                class="form-control form-control-xs number"
                                id="roll_code"
                                required=""
                                value={candidateData.schooL_CODE}
                                disabled
                              />
                            </div>
                          </div>
                          <div class="row mt-3">
                            <label class="col-md-3">Roll Number:</label>
                            <div class="col-md-3">
                              <input
                                class="form-control form-control-xs number"
                                id="roll_number"
                                value={candidateData.rolL_NO}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Name of Student</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled
                                    class="form-control form-control-sm disable count"
                                    name="candidate_name"
                                    placeholder="Cadidate Name"
                                    value={formData.candidate_name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender</label>
                                <select
                                  className="form-select form-select-sm"
                                  name="gender"
                                  disabled
                                  value={formData.gender?.toUpperCase()}
                                >
                                  <option value="">Select</option>
                                  <option value="MALE">MALE</option>
                                  <option value="FEMALE">FEMALE</option>
                                  <option value="TRANSGENDER">
                                    TRANSGENDER
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Date of Birth{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <DatePicker
                                  minDate={new Date(1975, 0, 1)}
                                  maxDate={new Date(2011, 2, 1)}
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                          const [dd, mm, yyyy] =
                                            formData.date_of_birth.split("-");
                                          return new Date(
                                            Number(yyyy),
                                            Number(mm) - 1,
                                            Number(dd)
                                          );
                                        })()
                                      : null
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  className={`form-control form-control-sm ${
                                    errors.date_of_birth ? "is-invalid" : ""
                                  }`}
                                  placeholderText="dd-mm-yyyy"
                                  disabled
                                  onKeyDown={(e) => e.preventDefault()}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                                {errors.date_of_birth && (
                                  <div className="text-danger mt-1 small">
                                    {errors.date_of_birth}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                              <div class="form-group  mb-3">
                                <label>Father’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="father_name"
                                    disabled
                                    class="form-control form-control-sm disable count1"
                                    value={formData.fathers_name}
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-4 col-md-4">
                              <div class="form-group  mb-3">
                                <label>Mother’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="mother_name"
                                    disabled
                                    class="form-control form-control-sm disable count2"
                                    value={formData.mothers_name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                              <div class="form-group  mb-3">
                                <label>Religion</label>
                                <div class="input-group">
                                  <select
                                    className={`form-select form-select-sm ${
                                      errors.religion ? "is-invalid" : ""
                                    }`}
                                    name="religion"
                                    id="religion"
                                    value={formData.religion || ""}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  >
                                    <option value="">Select</option>
                                    {religionList.map((religion) => (
                                      <option
                                        key={religion.religioN_ID}
                                        value={religion.religioN_ID}
                                      >
                                        {religion.religioN_NAME}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {errors.religion && (
                                  <div className="text-danger mt-1 small">
                                    {errors.religion}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-12">
                          <div class="form-group mb-3">
                            <label>
                              Divyang <span class="text-danger">*</span>
                            </label>
                            <select
                              className={`form-select form-select-sm ${
                                errors.divyang_val ? "is-invalid" : ""
                              }`}
                              id="divyang_val"
                              name="divyang_val"
                              value={formData.divyang_val}
                              onChange={handleChange}
                              disabled={isPreviewed}
                            >
                              <option value="">Select</option>
                              {divyangList.map((divyang) => (
                                <option
                                  key={divyang.divyanG_ID}
                                  value={divyang.divyanG_ID}
                                >
                                  {divyang.divyanG_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.divyang_val && (
                              <div className="text-danger mt-1 small">
                                {errors.divyang_val}
                              </div>
                            )}
                          </div>
                          <div class="form-group mb-3">
                            <label>
                              Caste <span class="text-danger">*</span>
                            </label>
                            <select
                              disabled
                              className={`form-select form-control-sm caste ${
                                errors.caste_val ? "is-invalid" : ""
                              }`}
                              name="caste_val"
                              id="caste_val"
                              value={formData.caste_val}
                              onChange={handleChange}
                            >
                              <option value="">Choose Caste</option>
                              {casteList.map((caste) => (
                                <option
                                  key={caste.castE_ID}
                                  value={caste.castE_ID}
                                >
                                  {caste.castE_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.caste_val && (
                              <div className="text-danger mt-1 small">
                                {errors.caste_val}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-9 col-m-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Category Choice</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.category_choice}
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Board Name</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  name="board_name"
                                  id="board_name"
                                  value={formData.board_name}
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group mb-3">
                                <label>Stream</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  name="faculty"
                                  id="faculty"
                                  value={formData.stream}
                                />
                              </div>
                            </div>
                          </div>
                          {formData.stream && (
                            <div class="row">
                              <div class="col-md-12 mb-3">
                                <h4>Core Subjects</h4>
                                <hr />
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>
                                        Core Language{" "}
                                        <span class="text-danger">*</span>
                                      </label>
                                      <select
                                        id="coresubject"
                                        className={`form-select  ${
                                          errors.coresubject ? "is-invalid" : ""
                                        }`}
                                        disabled={isPreviewed}
                                        name="coresubject"
                                        value={formData.coresubject || ""}
                                        onChange={(e) => {
                                          handleChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            coresubject: selectedText,
                                          }));
                                          const selectedValue = e.target.value;
                                          if (
                                            selectedValue === "ENA" ||
                                            selectedValue === "HNA"
                                          ) {
                                            setFormData((prev) => ({
                                              ...prev,
                                              matribhasa: "",
                                            }));
                                            setSelectedSubjectNames((prev) => ({
                                              ...prev,
                                              matribhasa: "",
                                            }));
                                          }
                                        }}
                                      >
                                        <option value="">Choose Subject</option>
                                        {coresubject
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.matribhasa,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];
                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );
                                            return (
                                              subject.subjecT_ID ===
                                                formData.coresubject || // ✅ Keep current selection
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>
                                      {errors.coresubject && (
                                        <div className="text-danger mt-1 small">
                                          {errors.coresubject}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>
                                        Matri Bhasa{" "}
                                        <span class="text-danger">*</span>
                                      </label>
                                      <select
                                        id="matribhasa"
                                        className={`form-select  ${
                                          errors.matribhasa ? "is-invalid" : ""
                                        }`}
                                        name="matribhasa"
                                        value={formData.matribhasa || ""}
                                        onChange={(e) => {
                                          handleChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            matribhasa: selectedText,
                                          }));
                                        }}
                                        disabled={
                                          formData.coresubject === "ENA" ||
                                          formData.coresubject === "HNA" ||
                                          isPreviewed ||
                                          !formData.coresubject
                                        }
                                      >
                                        <option value="">Choose Subject</option>
                                        {matribhasa
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.coresubject,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];
                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames
                                              );
                                            return (
                                              subject.subjecT_ID ===
                                                formData.matribhasa || // ✅ Keep current selection
                                              (!selectedIds.includes(
                                                subject.subjecT_ID
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>
                                      {errors.matribhasa && (
                                        <div className="text-danger mt-1 small">
                                          {errors.matribhasa}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {formData.stream === "SCIENCE" && (
                                <>
                                  <div
                                    class="col-md-12 mb-3"
                                    id="science_paper2"
                                  >
                                    <h4>Compulsory Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 1{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsoryonename}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 2{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsorytwoname}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12 mb-3"
                                    id="science_paper3"
                                  >
                                    <h4>Optional Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 1{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            className={`form-select ${
                                              errors.sc_optional_one
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={isPreviewed}
                                            id="sc_optional_one"
                                            name="sc_optional_one"
                                            value={optional1}
                                            onChange={(e) => {
                                              setOptional1(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional1: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional2 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    optional1
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove STA here
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                        "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is STA, remove MAT here
                                                  if (
                                                    (optional2 === "STA" ||
                                                      formData.additionalsubject ===
                                                        "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove CAE
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                        "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is CAE, remove MAT
                                                  if (
                                                    (optional2 === "CAE" ||
                                                      formData.additionalsubject ===
                                                        "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                    optional1 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            disabled={isPreviewed}
                                            className={`form-select ${
                                              errors.sc_optional_two
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            id="sc_optional_two"
                                            name="sc_optional_two"
                                            value={optional2}
                                            onChange={(e) => {
                                              setOptional2(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional2: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    optional2
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                        "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      formData.additionalsubject ===
                                                        "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                        "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      formData.additionalsubject ===
                                                        "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                    optional2 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12"
                                    id="science_additional"
                                  >
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">NONE</option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          artselective &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                    "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                    "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                      "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                      "MAT" ||
                                                    arts_optional_two ===
                                                      "MAT" ||
                                                    arts_optional_three ===
                                                      "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                        "MAT" ||
                                                      subject.subjecT_ID ===
                                                        "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                      "STA" ||
                                                    arts_optional_two ===
                                                      "STA" ||
                                                    arts_optional_three ===
                                                      "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                        "STA" ||
                                                      subject.subjecT_ID ===
                                                        "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                    formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {formData.stream === "COMMERCE" && (
                                <>
                                  <div
                                    class="col-md-12 mb-3"
                                    id="commerce_paper2"
                                  >
                                    <h4>Compulsory Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 1{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsoryonename}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 2{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsorytwoname}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12 mb-3"
                                    id="commerce_paper3"
                                  >
                                    <h4>Optional Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 1{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            className={`form-select ${
                                              errors.sc_optional_one
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={isPreviewed}
                                            id="sc_optional_one"
                                            name="sc_optional_one"
                                            value={optional1}
                                            onChange={(e) => {
                                              setOptional1(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional1: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional2 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    optional1
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove STA here
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                        "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is STA, remove MAT here
                                                  if (
                                                    (optional2 === "STA" ||
                                                      formData.additionalsubject ===
                                                        "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove CAE
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                        "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is CAE, remove MAT
                                                  if (
                                                    (optional2 === "CAE" ||
                                                      formData.additionalsubject ===
                                                        "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                    optional1 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            disabled={isPreviewed}
                                            className={`form-select ${
                                              errors.sc_optional_two
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            id="sc_optional_two"
                                            name="sc_optional_two"
                                            value={optional2}
                                            onChange={(e) => {
                                              setOptional2(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional2: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    optional2
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                        "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      formData.additionalsubject ===
                                                        "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                        "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      formData.additionalsubject ===
                                                        "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                    optional2 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12"
                                    id="commerce_additional"
                                  >
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">NONE</option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          artselective &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                    "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                    "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                      "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                      "MAT" ||
                                                    arts_optional_two ===
                                                      "MAT" ||
                                                    arts_optional_three ===
                                                      "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                        "MAT" ||
                                                      subject.subjecT_ID ===
                                                        "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                      "STA" ||
                                                    arts_optional_two ===
                                                      "STA" ||
                                                    arts_optional_three ===
                                                      "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                        "STA" ||
                                                      subject.subjecT_ID ===
                                                        "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                    formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {formData.stream === "ARTS" && (
                                <>
                                  <div class="col-md-12 mb-3" id="arts_paper2">
                                    <h4>Elective Subject</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Elective Language
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            className={`form-select ${
                                              errors.arts_elective_one
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={isPreviewed}
                                            id="arts_elective_one"
                                            name="arts_elective_one"
                                            value={artselective}
                                            onChange={(e) => {
                                              setArtselective(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  artselective: selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {electivefiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected =
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          formData.additionalsubject &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    artselective
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                    "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                    "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                      "FEN")
                                                ) {
                                                  return false;
                                                }
                                                return (
                                                  subject.subjecT_ID ===
                                                    artselective ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                          {errors.arts_elective_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_elective_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12 mb-3" id="arts_paper3">
                                    <h4>Optional Subjects</h4>
                                    <hr />

                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 1
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            className={`form-select ${
                                              errors.arts_optional_one
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={isPreviewed}
                                            id="arts_optional_one"
                                            name="arts_optional_one"
                                            value={
                                              selectedArtsSubjects.arts_optional_one
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_one:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                // ✅ Vocational restriction: only one vocational allowed
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some((id) => {
                                                  if (!id) return false;
                                                  return (
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    ) ||
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    ) ||
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    )
                                                  );
                                                });

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    selectedArtsSubjects.arts_optional_one
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion for Arts
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                ];
                                                if (
                                                  artsOptionals.includes(
                                                    "MAT"
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA"
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                    selectedArtsSubjects.arts_optional_one ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                          {errors.arts_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            disabled={isPreviewed}
                                            className={`form-select ${
                                              errors.arts_optional_two
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            id="arts_optional_two"
                                            name="arts_optional_two"
                                            value={
                                              selectedArtsSubjects.arts_optional_two
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_two:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some(
                                                  (id) =>
                                                    id &&
                                                    (artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    ) ||
                                                      optionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational === "YES"
                                                      ) ||
                                                      additionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational === "YES"
                                                      ))
                                                );

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    selectedArtsSubjects.arts_optional_two
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                ].filter(Boolean);

                                                if (
                                                  artsOptionals.includes(
                                                    "MAT"
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA"
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                return (
                                                  subject.subjecT_ID ===
                                                    selectedArtsSubjects.arts_optional_two ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.arts_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 3{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            disabled={isPreviewed}
                                            className={`form-select ${
                                              errors.arts_optional_three
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            id="arts_optional_three"
                                            name="arts_optional_three"
                                            value={
                                              selectedArtsSubjects.arts_optional_three
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_three:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some(
                                                  (id) =>
                                                    id &&
                                                    (artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES"
                                                    ) ||
                                                      optionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational === "YES"
                                                      ) ||
                                                      additionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational === "YES"
                                                      ))
                                                );

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    selectedArtsSubjects.arts_optional_three
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                ].filter(Boolean);

                                                if (
                                                  artsOptionals.includes(
                                                    "MAT"
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA"
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                return (
                                                  subject.subjecT_ID ===
                                                    selectedArtsSubjects.arts_optional_three ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.arts_optional_three && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_three}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12" id="arts_additional">
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                })
                                              );
                                            }}
                                          >
                                            <option value="">NONE</option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional1 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          optional2 &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES"
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                          artselective &&
                                                        s.vocational === "YES"
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                    "YES" &&
                                                  subject.subjecT_ID !==
                                                    formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                    "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                    "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                      "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                      "MAT" ||
                                                    arts_optional_two ===
                                                      "MAT" ||
                                                    arts_optional_three ===
                                                      "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                        "MAT" ||
                                                      subject.subjecT_ID ===
                                                        "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                      "STA" ||
                                                    arts_optional_two ===
                                                      "STA" ||
                                                    arts_optional_three ===
                                                      "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                        "STA" ||
                                                      subject.subjecT_ID ===
                                                        "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                    formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Other Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="form-group mb-3">
                        <label>
                          Permanent Education Number (PEN){" "}
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          id="pen_no"
                          name="pen_no"
                          className={`form-control form-control-sm ${
                            errors.pen_no ? "is-invalid" : ""
                          }`}
                          placeholder="Enter PEN NO"
                          value={formData.pen_no}
                          maxlength="14"
                          onBlur={handlePenBlur}
                          onChange={(e) => {
                            const onlyNums2 = e.target.value.replace(/\D/g, "");
                            handleChange({
                              target: { name: "pen_no", value: onlyNums2 },
                            });
                          }}
                          disabled={isPreviewed}
                        />
                        {errors.pen_no && (
                          <div className="text-danger mt-1 small">
                            {errors.pen_no}
                          </div>
                        )}
                      </div>
                      <div class="form-group mb-3">
                        <label>APAAR ID</label>
                        <input
                          maxlength="12"
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          id="apaar_id"
                          name="apaar_id"
                          className={`form-control form-control-sm ${
                            errors.apaar_id ? "is-invalid" : ""
                          }`}
                          placeholder="Enter APAAR ID"
                          value={formData.apaar_id}
                          onChange={(e) => {
                            const onlyNums = e.target.value.replace(/\D/g, "");
                            handleChange({
                              target: { name: "apaar_id", value: onlyNums },
                            });
                          }}
                          disabled={isPreviewed}
                        />
                        {errors.apaar_id && (
                          <div className="text-danger mt-1 small">
                            {errors.apaar_id}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer12 />
          </div>
        </div>
      </div>
    </>
  );
}

export default CorrectRegular12;
